// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"d56714cb","337":"eaafe408","453":"fc10e80e"}[chunkId] + ".chunk.js";
};